<template>
  <JsonExcel v-bind="[$props, $attrs]" :data="exportData">
    <slot />
  </JsonExcel>
</template>
<script>
import JsonExcel from "vue-json-excel";
export default {
  name: "breadCrumb",
  components: {
    JsonExcel,
  },
  props: ['data'],
  data() {
    return {
      exportData: [],
    }
  },
  watch: {
    'data'(val) {
      this.exportData = JSON.parse(JSON.stringify(val))

			try {
        let fields = []
        for(let key in this.$attrs.fields) {
          fields.push(this.$attrs.fields[key])
        }

				for(let row of this.exportData) {
					for(let field of fields) {
            if(field && field.includes('.')) {
              let keys = field.split('.')
              let temp = row
              for(let i=0; i<keys.length; i++) {
                if(i === keys.length - 1) {
                  let value = '' + temp[keys[i]]
                  if(!value.startsWith('"') && !value.endsWith('"')) {
                    temp[keys[i]] = `"${value}"`
                  }
                } else {
                  temp = temp[keys[i]]
                }
              }
            } else {
              let value = '' + row[field]
              if(!value.startsWith('"') && !value.endsWith('"')) {
                row[field] = `"${value}"`
              }
            }            
					}
				}
			} catch(e) {
				console.error(e)
			}
    },
  },
};
</script>